import { IInteractionsCount } from "@edgetier/watchtower-types";

export const formatPerformanceChartData = (currentPhraseTriggerId: string, queryData?: IInteractionsCount<any>[]) => {
    if (typeof queryData !== "undefined") {
        const chartData: Record<string, any> = queryData.reduce((previousData, currentEntry) => {
            const [dateGroup, phraseTriggerId] = currentEntry.group;
            const dateTime = new Date(dateGroup).getTime();

            return {
                ...previousData,
                [dateTime]: {
                    ...(typeof previousData[dateTime] === "undefined" ? { dateTime } : previousData[dateTime]),
                    phraseTriggerId: currentPhraseTriggerId,
                    ...(currentPhraseTriggerId === phraseTriggerId ? { count: currentEntry.count } : {}),
                },
            };
        }, {} as Record<string, any>);

        return Object.values(chartData);
    }
    return [];
};
